import React, { useState } from 'react';
import { loginValidation } from '../../validation/yupSchema';
import { callAdminLogin } from '../../api-services/index';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useMutation } from 'react-query';
import { Link, useNavigate } from 'react-router-dom';
import swal from 'sweetalert';
import Logo from '../../assets/images/logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const Login = () => {
  const [passwordType, setPasswordType] = useState(false);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(loginValidation),
    mode: 'onSubmit',
  });

  const { isLoading, mutateAsync } = useMutation(
    'admin-login',
    callAdminLogin,
    {
      onSuccess: (data) => {
        if (data && data.data && data.data.success) {
          localStorage.setItem(
            'token',
            JSON.stringify(data.data.data.access_token),
          );
          navigate('/user');
        }
      },
      onError: (error) => {
        swal({
          title: 'Error!',
          text: error?.response?.data?.message ?? 'Something went wrong!',
          type: 'danger',
          icon: 'error',
        });
      },
    },
  );

  const handleSubmitForm = async (values) => {
    await mutateAsync(values);
  };
  return (
    <>
      <div className="body-content-outer" style={{ height: '100vh' }}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6 offset-md-3 box-shadow bg-white radius-5 p-3">
              <div className="content-header">
                <Link className="logo" to="#">
                  <img src={Logo} alt="Logo" width="100" />
                </Link>
              </div>
              <div className="content-body">
                <form
                  className="m-0 form-fields"
                  onSubmit={handleSubmit(handleSubmitForm)}
                >
                  <div className="form-group">
                    <input
                      {...register('email')}
                      type="email"
                      name="email"
                      maxLength="50"
                      placeholder="Email"
                      className="form-control"
                    />
                    <p>{errors.email?.message}</p>
                  </div>
                  <div className="form-group position-relative">
                    {
                      <span
                        className="input-icon"
                        style={{ fontSize: 14, fontWeight: 'bold' }}
                        onClick={() => setPasswordType((val) => !val)}
                      >
                        {passwordType ? (
                          <FontAwesomeIcon icon={faEye} />
                        ) : (
                          <FontAwesomeIcon icon={faEyeSlash} />
                        )}
                      </span>
                    }
                    <input
                      {...register('password')}
                      type={passwordType ? 'text' : 'password'}
                      name="password"
                      maxLength="20"
                      required=""
                      placeholder="Password"
                      className="form-control"
                    />
                    <p>{errors.password?.message}</p>
                  </div>
                  <div className="form-group text-center mt-4">
                    <button type="submit" className="btn btn-primary">
                      {isLoading ? 'Please wait...' : 'Login'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
